module.exports = __webpack_public_path__ + "static/media/solarPannelCorrect.a771cd16.png";